import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ViaSurveyBeforeProgramComponent } from './viaSurveyBeforeProgram.component';
import { SharedModule } from '@shared/shared.module';
import { ViaSurveyBeforeProgramRoutingModule } from './viaSurveyBeforeProgram-routing.module';
import { CourseContentModule } from '@app/courseContent/courseContent.module';

@NgModule({
  imports: [CommonModule, SharedModule, ViaSurveyBeforeProgramRoutingModule, CourseContentModule],
  declarations: [ViaSurveyBeforeProgramComponent],
})
export class ViaSurveyBeforeProgramModule {}
